<template>
  <footer class="footer">
    <ul class="footer__socials">
      <li class="footer__socials-item">
        <router-link
          to="/contact-us"
          class="link footer__socials-link"
          :class="{ 'link--white': withWhiteLinks }"
        >contact us</router-link>
      </li>
      <li class="footer__socials-item">
        <a
          href="https://www.instagram.com/annamor.ph"
          class="link footer__socials-link"
          :class="{ 'link--white': withWhiteLinks }"
        >
          <unicon name="instagram" :width="iconSize" :height="iconSize"></unicon>
        </a>
      </li>
      <li class="footer__socials-item">
        <a
          href="https://www.facebook.com/profile.php?id=100005625678689"
          class="link footer__socials-link"
          :class="{ 'link--white': withWhiteLinks }"
        >
          <unicon name="facebook-f" :width="iconSize" :height="iconSize"></unicon>
        </a>
      </li>
    </ul>
  </footer>
</template>

<script>
export default {
  data: () => ({
    iconSize: 40
  }),
  props: {
    withWhiteLinks: {
      type: Boolean,
      default: false
    }
  }
};
</script>
